"use User";

import { useState } from "react";
import { useToast } from "../components/context/ToastContext";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { IUser } from "../interfaces/user";
import { fetchUser, saveUser } from "../services/userService";
import { jwtDecode } from "jwt-decode";

export function useUser(initialPage: number = 1) {
  const showToast = useToast();
  const queryUser = useQueryClient();

  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(initialPage);

  let objUserTk: any;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token") || "") as any;
  } else {
    objUserTk = {};
  }

  const UserQuery = useQuery<
    { items: IUser[]; totalCount: number },
    Error,
    { User: IUser[]; totalPages: number }
  >({
    queryKey: ["User", pageNumber, search] as const,
    queryFn: () => fetchUser(pageNumber, search),
    select: (apiResponse: any) => {
      const items =  apiResponse.data.data || [];
      const totalPages = apiResponse.data.totalPages || 1;
      console.log("items", items);
      return { User: items, totalPages };
    },
    //@ts-ignore
    onError: () => {
      showToast("error", "Erro ao buscar usuários.");
    },
  });

  const saveMutation = useMutation({
    mutationFn: ({
      data,
      editando,
      userId,
    }: {
      data: IUser;
      editando: boolean;
      userId?: number;
    }) => saveUser(data, editando, userId),
    onSuccess: () => {
      queryUser.invalidateQueries({ queryKey: ["User"] });
      showToast("success", "Usuário salvo com sucesso.");
    },
    onError: (err: any, variables: any) => {
     showToast("error", "Erro ao salvar usuário.");
    },
  });

  // const deleteMutation = useMutation({
  //   mutationFn: (userId: number) => deleteUser(userId),
  //   onSuccess: () => {
  //     queryUser.invalidateQueries({ queryKey: ["User"] });
  //     toast({
  //       variant: "success",
  //       title: "Sucesso.",
  //       description: "Usuário removido com sucesso.",
  //     });
  //   },
  //   onError: (err: any) => {
  //     toast({
  //       variant: "destructive",
  //       title: "Erro ao remover.",
  //       description: err.message || "Não foi possível remover o Usuário.",
  //     });
  //   },
  // });

  function handleSave(data: IUser, editando: boolean, userId?: number) {
    data.idClient = objUserTk.IdClient;

    if (objUserTk.Rule === "Master") { 
      data.rule = "Comum";
    }
    console.log("data", data);
    saveMutation.mutate({ data, editando, userId });
  }

  // function handleDelete(userId: number) {
  //   deleteMutation.mutate(userId);
  // }

  return {
    User: UserQuery.data?.User || [],
    totalPages: UserQuery.data?.totalPages || 1,
    isLoading: UserQuery.isLoading,

    // estado de salvamento (mutation)
    isSaving: saveMutation.status === "pending",

    search,
    setSearch,
    pageNumber,
    setPageNumber,

    handleSave,

    refetchUser: UserQuery.refetch,
  };
}
